import {
  Box,
  Button,
  Divider,
  ListItem,
  ListItemButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material"
import { IOrderBump } from "../../../../../core/types/OrderBump"
import numbers from "../../../../../core/functions/NumberFunctions"
import React, { useEffect, useState } from "react"
import { TPaymentMethodEnum } from "../../../../../core/types/Product"
import BpCheckbox from "../../../../Inputs/BpCheckboxGreen"
import { EditableTypography } from "../../../../Typographys/EditableTypography"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"

interface ICheckoutOrderBump8Prop {
  paymentInstallment: number
  paymentMethodType: number
  orderBump: IOrderBump
  onChange(orderBump: IOrderBump): void
}

const CheckoutOrderBump8 = ({
  paymentInstallment,
  paymentMethodType,
  orderBump,
  onChange,
}: ICheckoutOrderBump8Prop): JSX.Element => {
  const paymentsAccept = [
    TPaymentMethodEnum.CreditCard,
    TPaymentMethodEnum.TwoCreditCard,
    TPaymentMethodEnum.CreditCardAndPix,
  ]

  const containsInstallments =
    orderBump.installments && orderBump.installments.length > 0

  const isInstallments =
    paymentsAccept.includes(paymentMethodType) &&
    containsInstallments &&
    paymentInstallment > 1

  const value =
    orderBump.productPrice?.firstPurchasePrice ?? orderBump.productPrice?.value

  const installmentValue = isInstallments
    ? orderBump.installments?.find(
        (o) => o.installmentNumber === paymentInstallment
      )?.value
    : null

  const orderBumpValue = installmentValue ?? value

  const [typedText, setTypedText] = useState("")

  const handleClick = () => {
    orderBump.selected = !orderBump.selected
    onChange(orderBump)
  }

  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down("md")
  )

  useEffect(() => {
    if (orderBump.selected) {
      const fullText = "PRODUTO ADICIONADO"
      let index = 0
      setTypedText("")

      const typing = setInterval(() => {
        setTypedText((prev) => prev + fullText.charAt(prev.length))
        index++

        if (index >= fullText.length) {
          setTypedText("PRODUTO ADICIONADO")
          clearInterval(typing)
        }
      }, 50) // Velocidade da digitação

      return () => clearInterval(typing)
    } else {
      setTypedText("") // limpa se desmarcar
    }
  }, [orderBump.selected])

  const isSelected = orderBump.selected ?? false

  return (
    <>
      <ListItem key={`ob-${orderBump.id}`} disablePadding>
        <Box sx={{ position: "relative", width: "100%" }}>
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              zIndex: 2,
              pointerEvents: "none",
              borderRadius: "20px",
              background:
                "radial-gradient(circle at center, rgba(255,255,255,0.4) 0%, rgba(62,191,144,0.2) 80%)",
              backdropFilter: "blur(1.2px)",
              //display: "flex",
              display: "none",
              alignItems: "center",
              justifyContent: "center",
              transition: "opacity 0.3s ease",
              opacity: isSelected ? 1 : 0,
              m: 0.3,
              mb: 2.3,
            }}
          >
            <Typography
              fontSize="18px"
              fontWeight={600}
              color="#3ebf90"
              sx={{ zIndex: 3 }}
            >
              {typedText}
            </Typography>
          </Box>
          <ListItemButton
            dense
            role={undefined}
            className="listItemButtonOrderBump"
            onClick={handleClick}
            sx={{
              py: 0,
              px: 1,
              borderRadius: "20px",
              mb: 2,
              //border: "2px dashed #3ebf90",
            }}
          >
            <Stack direction={"column"} width="100%">
              <Box
                sx={{
                  width: "100%",
                  backgroundColor: "#fbfbfb",
                  //display: "flex",
                  display: "none",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  borderRadius: "10px",
                  //border: "2px dashed #3ebf90",
                  //borderBottom: "0px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                padding={1}
              >
                <Stack
                  width="100%"
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ pr: 1 }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Box>
                      <BpCheckbox checked={isSelected} />
                    </Box>
                    <Typography
                      variant="h5"
                      fontWeight={500}
                      fontFamily="Montserrat"
                      fontSize="14px"
                      lineHeight="14px"
                      color="#3ebf90"
                    >
                      {/*orderBump.title*/}
                      Adicionar receitas!
                    </Typography>
                  </Stack>
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    fontFamily="Montserrat"
                    fontSize="14px"
                    lineHeight="14px"
                    color="#3ebf90"
                  >
                    {numbers.formatMoneyCurrency(orderBumpValue, orderBump.productPrice?.currency)}
                  </Typography>
                </Stack>
              </Box>

              <Stack sx={{ backgroundColor: "transparent" }}>
                <Box p={{ xs: 1, sm: 2 }}>
                  <Box
                    sx={{
                      backgroundColor: "transparent",
                      gap: "8px",
                      borderRadius: "10px",
                    }}
                  >
                    <Box width="100%" sx={{ flexGrow: 1, display: "flex" }}>
                      <Box width="100%">
                        <Stack
                          direction="row"
                          sx={{ width: "100%", pl: { xs: 0, sm: 1 }, pr: 0 }}
                          alignItems={{ xs: "center", sm: "start" }}
                          gap={{ xs: "12px", sm: "12px" }}
                        >
                          <Box
                            sx={{
                              borderRadius: "8px",
                              mt: 1,
                            }}
                          >
                            {orderBump.productPrice?.product?.coverUrl &&
                              orderBump.productPrice?.product?.coverUrl !==
                                "" && (
                                <img
                                  src={
                                    !orderBump.productPrice?.product?.coverUrl
                                      ? `${process.env.PUBLIC_URL}/top.png`
                                      : orderBump.productPrice.product.coverUrl
                                  }
                                  alt={orderBump.productPrice?.product?.name}
                                  style={{
                                    height: isSmallScreen ? 124 : 150,
                                    width: isSmallScreen ? 124 : 150,
                                    objectFit: "cover",
                                    borderRadius: "16px",
                                  }}
                                />
                              )}
                          </Box>
                          <Stack
                            direction={"column"}
                            spacing={1}
                            sx={{ flexGrow: 1, width: "100%", pt: 1 }}
                          >
                            <Typography
                              variant="h5"
                              fontFamily="Montserrat"
                              fontSize="16px"
                              lineHeight="20px"
                              fontWeight={600}
                              color="#343948"
                            >
                              {orderBump.title}
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="Montserrat"
                              fontSize="12px"
                              lineHeight="20px"
                              fontWeight={400}
                              color="rgba(56, 57, 59, 1)"
                            >
                              <EditableTypography
                                htmlContent={orderBump.description ?? ""}
                              />
                            </Typography>
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Typography
                                variant="h5"
                                fontWeight={600}
                                fontFamily="Montserrat"
                                fontSize="14px"
                                lineHeight="14px"
                                color="#343948"
                              >
                                {numbers.formatMoneyCurrency(orderBumpValue, orderBump.productPrice?.currency)}
                              </Typography>
                              <Button
                                variant={isSelected ? "contained" : "outlined"}
                                size="small"
                                startIcon={
                                  isSelected ? <RemoveIcon /> : <AddIcon />
                                }
                                sx={{
                                  borderRadius: "10px",
                                  textTransform: "none",
                                  color: isSelected ? "#FFFFFF" : "#4CBF88",
                                  borderColor: "#4CBF88",
                                  backgroundColor: isSelected
                                    ? "#4CBF88"
                                    : "transparent",
                                  bgcolor: isSelected
                                    ? "#4CBF88"
                                    : "transparent",
                                  "&:hover": {
                                    borderColor: "#4CBF88",
                                    backgroundColor: isSelected
                                      ? "#4CBF88"
                                      : "transparent",
                                    bgcolor: isSelected
                                      ? "#4CBF88"
                                      : "transparent",
                                  },
                                  "&:active": {
                                    borderColor: "#4CBF88",
                                    backgroundColor: isSelected
                                      ? "#4CBF88"
                                      : "transparent",
                                    bgcolor: isSelected
                                      ? "#4CBF88"
                                      : "transparent",
                                  },
                                  "&.Mui-focusVisible": {
                                    borderColor: "#4CBF88",
                                    backgroundColor: isSelected
                                      ? "#4CBF88"
                                      : "transparent",
                                    bgcolor: isSelected
                                      ? "#4CBF88"
                                      : "transparent",
                                  },
                                }}
                              >
                                {isSelected ? "Remover" : "Adicionar"}
                              </Button>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Stack>
              <Divider />
            </Stack>
          </ListItemButton>
        </Box>
      </ListItem>
    </>
  )
}

export default CheckoutOrderBump8
